<template>
  <div class="container">

    <div class="text-center">
      <img src="/static/ccall.png" class="logo-ccall mt30per" width="200" />
    </div>

    <div class="medial-body">
      <p>{{$t('medial.loginBy')}}</p>
      <router-link :to="{name: 'Account'}"><base-button>{{ name }}</base-button></router-link>
      <!--<p @click="logout()">{{$t('medial.forgotAccount')}}</p>-->
      <p @click="logout()" class="mt10">{{$t('medial.loginOtherAccount')}}</p>
    </div>

    <!--
    <div class="medial-footer">
      <p @click="logout()">{{$t('medial.loginOtherAccount')}}</p>
      <router-link :to="{name: ''}" class="private-policy-link">{{$t('medial.privatePolicyAndCookie')}}</router-link>
    </div>
    -->

  </div>
</template>

<script>
import BaseButton from "../components/Button.vue";

export default {
  components: {
    BaseButton
  },
  name: 'MedialPage',
  data() {
    return {
      msg: 'Welcome to CCALL',
      name: '...',
    };
  },
  methods: {
    logout() {
      const token = localStorage.getItem('token');
      this.axios.post('/logout?token=' + token).then((response) => {
        if (response.data.status) {
          localStorage.removeItem('token');
          localStorage.removeItem('url');
        }
        this.$router.push({name: 'LoginPage'});
      });
    },
  },
  beforeMount() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.$router.push({name: 'LoginPage'});
    }

    if (token) {
      this.axios.get('/getData?token=' + token).then((response) => {
        if ((response.data.status)) {
          this.name = response.data.data.name;
        } else {
          this.$router.push({name: 'LoginPage'});
        }
      });
    }

  }
};
</script>

<style scoped="">
  .btn {
    min-width: 70%;
    width: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/MedialPage.vue